'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProvideProps2 = require('./ProvideProps');

var _ProvideProps3 = _interopRequireDefault(_ProvideProps2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Value = function (_ProvideProps) {
  (0, _inherits3.default)(Value, _ProvideProps);

  function Value() {
    (0, _classCallCheck3.default)(this, Value);
    return (0, _possibleConstructorReturn3.default)(this, _ProvideProps.apply(this, arguments));
  }

  Value.prototype.getProps = function getProps() {
    return {
      value: this.getValue()
    };
  };

  return Value;
}(_ProvideProps3.default);

exports.default = Value;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Value.js
 ** module id = 1283
 ** module chunks = 0
 **/